import { LottieSpinner } from '../LottieSpinner/LottieSpinner'

export const Loader = () => {
  return <LottieSpinner width={10} height={10} />
}
